import ProgressBar from '@perpay-web/components/base/ProgressBar/ProgressBar';
import Inline from '@perpay-web/components/design-system/Inline/Inline';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './FocusHeader.scss';

/**
 * @param {Object} props
 * @param {number} [props.steps]
 * @param {number} [props.currentStep]
 * @param {string} [props.title]
 * @param {React.ReactNode} [props.titleElement]
 * @param {React.ReactNode} [props.leftButtonElement]
 * @param {React.ReactNode} [props.rightButtonElement]
 * @param {string} [props.className]
 */
const FocusHeader = ({
    steps = null,
    currentStep = 0,
    title = '',
    titleElement = null,
    leftButtonElement = null,
    rightButtonElement = null,
    className = '',
}) => (
    <Inline className={getClassName(styles.header__public, className)}>
        {leftButtonElement}
        {titleElement != null ? titleElement : null}
        {title ? (
            <span className={getClassName(styles.title)}>{title}</span>
        ) : null}
        {steps ? (
            <div className={styles['progress-bar']}>
                <ProgressBar steps={steps} currentStep={currentStep} />
            </div>
        ) : null}
        {rightButtonElement}
    </Inline>
);

export default FocusHeader;
